<template>
  <div
    class="
      col-span-6
      sm:col-span-3
      xl:col-span-2
      flex flex-col
      justify-end
      items-center
    "
    v-if="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div v-if="!loading">
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <TagIcon />
      <h2 class="text-lg font-medium mr-auto">
        {{ $t('branchPlace.detail') }}
      </h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          :to="{ name: 'side-menu-branch-places' }"
          tag="a"
          class="btn shadow-md flex items-center"
        >
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          border-b border-gray-200
          dark:border-dark-5
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div class="ml-5">
            <div
              class="
                w-24
                sm:w-40
                truncate
                sm:whitespace-normal
                font-medium
                text-lg
              "
            >
              {{ branchPlace.internalName }}
            </div>
            <div class="text-gray-600">
              {{ branchPlace.name.sk_SK }}
              <hr />
              {{ branchPlace.description.sk_SK }}
            </div>
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="font-medium text-center lg:text-left lg:mt-3">
            {{ $t('common.detail') }}
          </div>
          <div
            class="
              flex flex-col
              justify-center
              items-center
              lg:items-start
              mt-4
            "
          >
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <EyeIcon class="w-4 h-4 mr-2" v-if="branchPlace.visible" />
              <EyeOffIcon class="w-4 h-4 mr-2" v-if="!branchPlace.visible" />
              {{ $t('common.visibility') }}
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <CheckCircleIcon class="w-4 h-4 mr-2" v-if="branchPlace.active" />
              <CircleIcon class="w-4 h-4 mr-2" v-if="!branchPlace.active" />
              {{ $t('common.active') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="
          flex flex-col
          lg:flex-row
          pb-5
          -mx-5
        "
      >
        <div
          class="flex flex-1 px-5 items-center justify-center lg:justify-start"
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <BranchBindList :selectedBranches="[branchPlace.branch]" />
          </div>
        </div>
        <div
          class="
            mt-6
            lg:mt-0
            flex-1
            dark:text-gray-300
            px-5
            border-l border-r border-gray-200
            dark:border-dark-5
            border-t
            lg:border-t-0
            pt-5
            lg:pt-0
          "
        >
          <div class="truncate sm:whitespace-normal flex items-center">
            <ServiceBindList :selectedServices="branchPlace.services" />
          </div>
        </div>
      </div>
    </div>
    <div class="intro-y box p-5 mt-5">
      <Calendar :branchPlace="this.$route.params.uuid" />
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-load-notification-content"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('branchPlace.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import Toastify from 'toastify-js'
import branchPlaceApi from '@/services/branches/branch-place.api'
import Calendar from '../../components/reservations/Calendar.vue'
import BranchBindList from '@/components/branches/BranchBindList.vue'
import ServiceBindList from '@/components/services/ServiceBindList.vue'

export default defineComponent({
  components: {
    Calendar,
    BranchBindList,
    ServiceBindList
  },
  methods: {},
  computed: {
    console: () => console
  },
  data() {
    return {
      branchPlace: {}
    }
  },
  mounted() {
    branchPlaceApi.getDetail(this.$route.params.uuid).then(
      response => {
        this.branchPlace = response.data

        this.loading = false
      },
      error => {
        console.log(error)
        Toastify({
          node: cash('#failed-load-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'side-menu-branch-places' })
      }
    )
  },
  setup() {
    const loading = ref(true)

    return {
      loading
    }
  }
})
</script>
